<template>
  	<div>
		<div class="page-wrapper">
			<article>
				<header class="article-head">
					<div class="article-head__top">
						<ul class="article-details">
							<li class="article-details__item article-details__item--calendar">November 04, 2019</li>
							<li class="article-details__item">Montreal, QC</li>
							<li class="article-details__item">By Lisa Gaetz</li>
						</ul>
						<!--<ul class="social-links">
							<li class="social-links__item">1</li>
							<li class="social-links__item">2</li>
							<li class="social-links__item">3</li>
							<li class="social-links__item">4</li>
						</ul>-->
					</div>
					<h1 class="title title--main">HiCentral MLS Selects MLS-Touch Mobile App for Its 6,500+ Members</h1>
				</header>
                <p>MONTREAL, QC, and HONOLULU, HI, November 04, 2019 -- Prospects Software, a provider of premium agent productivity and marketing solutions, announced today an agreement with HiCentral MLS to bring its widely adopted MLS-Touch mobile MLS app to Oahu’s 6,500+ agents, as a member benefit.</p>
                <p>MLS-Touch, available for both iOS and Android devices, helps agents manage their business like never before. It has all the features agents need when they’re on the go including advanced listing searches, contact and lead management, market stats, hotsheets, comparables, listing edit, and seamless integrations with Matrix™, Realist® and ShowingTime. Agents also have the ability to create and share their own branded app in seconds, giving clients access to all listings in the market and allowing for easy collaboration.</P>
                <p>“It’s very important to us to partner with the leading providers of real estate technology,” said Suzanne Young, CEO of HiCentral MLS. “We’re very impressed with MLS-Touch and confident this will be a game changer for our members in terms of how they’re able to manage their business and their clients while they’re out in the field.”</p>
                <p>“Agents, more than ever before, need to be connected to their listings, leads, and contacts at all times so they can stay ahead of their clients’ demands,” said Charles Drouin, CEO of Prospects Software. “We are very excited and proud to partner with HiCentral to bring our premium mobile app to their members.”</p>
                <p>A member of the CoreLogic Alliance Network, Prospects Software continues to grow its footprint in North America and now provides solutions to over 280,000 real estate agents. MLS-Touch will be available to HiCentral MLS members in early December.</p>
                <h3 class="title title--sub">About Prospects Software</h3>
                <p>Prospects Software provides two of the most critical tools that real estate professionals rely on every day beyond their primary MLS - mobile MLS and CRM. MLS-Touch, also known as Prospects Mobile in Canada, keeps agents connected to listings, leads and contacts from anywhere, on any device. Prospects CRM gives agents a powerful tool to organize contacts and manage customer relationships. Prospects apps are intelligent, easy-to-use, and fully integrated with each other and with the CoreLogic Matrix multiple listing platform. For more information, visit <br><a href="https://www.prospects.com/en/ca/home" class="link" target="blank">www.prospects.com</a>.</p>
                <h3 class="title title--sub">About HiCentral MLS</h3>
                <p>HiCentral MLS is a wholly owned subsidiary of the Honolulu Board of REALTORS® (HBR), one of the largest trade organizations on Oahu. HiCentral provides MLS services to HBR members and its website, <a href="https://hicentral.com/?fbclid=IwAR3_oK0IJF30iJZOJVhVlOJLIAKsxD2Z_6L_6G6pce-E3ah8npDp5P6SRGQ" class="link" target="blank">HiCentral.com</a>, is the premier provider of real estate tools and information in Hawaii.</p>				
				<footer class="article-foot">
					<h3 class="title title--sub">Press Contact</h3>
					<p>Lisa Gaetz<br>Director of Marketing<br><a href="mailto:lisa@prospects.com">lisa@prospects.com</a><br>Phone: <a href="phone:8887659223">(888) 765-9223 ext.207</a></p>
				</footer>
			</article>
		</div>
  	</div>
</template>


<script>
import Introducer from '@/components/utils/Introducer.vue'

export default {
	components: { Introducer },

	mounted () {	
	},

	data () {
		 return {
		 }
	},

	computed: {

	},

	methods: {
	}
};
</script>

<style lang="scss">
	@import url('https://fonts.googleapis.com/css?family=Libre+Baskerville:400i&display=swap');

	$quote-font: 'Libre Baskerville', serif;
	$news-font : 'Montserrat', sans-serif;

	//breakpoints
	$screen-sm: 576px;
	$screen-md: 768px;
	$screen-lg:	992px;
	$screen-xl:	1280px;

	//breakpoints mixin

	@mixin media-breakpoint-up($class) {

	  @if $class == sm {
	    @media (min-width: $screen-sm) { @content; }
	  }

	  @else if $class == md {
	    @media (min-width: $screen-md) { @content; }
	  }

	  @else if $class == lg {
	    @media (min-width: $screen-lg) { @content; }
	  }

	   @else if $class == xl {
	    @media (min-width: $screen-xl) { @content; }
	  }

	  @else {
	    @warn "Breakpoint mixin supports: xs, sm, md, lg";
	  }
	}
//main article font
@mixin newsFont($colour: false, $size: false, $weight: false,  $lh: false) {
    font-family: $news-font, Helvetica, Arial, sans-serif;
    //@if $size { font-size: $size; }
    @if $colour { color: $colour; }
    @if $size { font-size: $size; }
    @if $weight { font-weight: $weight; }
    @if $lh { line-height: $lh; }
}

	.article-head {
		margin: 40px 0;
		padding: 0 0 20px;
		border-bottom: 1px solid #ccc;
	}
	.article-head__top {
		display: flex;
		justify-content: space-between;
	}
	.article-details {
		list-style-type: none;
		display: flex;
		margin-bottom: 2em;
		@include newsFont (#000, 12px, 400, 18px);
		@include media-breakpoint-up(sm) {
			@include newsFont (#000, 16px, 400, 20px);
		}
	}
	.article-details__item {
		margin-right: 1em;
		display: flex;
		&:after {
			content: '|';
			margin-left: 1em;
		}
		&:last-child {
			&:after {
				content: none;
			}
		}
		&--calendar {
			&:before {
				content: url(./../../assets/calendar.svg);
				width: 17px;
				height: 17px;
				margin-right: 10px;
			}
		}
	}
	.social-links {
		list-style-type: none;
		display: flex;
	}
	.social-links__item {
		margin-left: 10px;
	}
	.title {
		margin-bottom: 1em;
	}
	.title--main {
		@include newsFont (#000, 20px, 500, 30px);
		text-transform: uppercase;
		margin-bottom: 1em;
		@include media-breakpoint-up(sm) {
			@include newsFont (#000, 27px, 200, 40px);
		}
		@include media-breakpoint-up(lg) {
			@include newsFont (#000, 48px, 200, 52px);
			width: 75%;
		}
	}
	.title--secondary {
		@include newsFont (#000, 22px, 400, 26px);
	}
	.title--sub {
		@include newsFont (#000, 18px, 700, 20px);
	}
	.link {
		color: #e02428;
		word-break: break-all;
		font-weight: 400;
	}
	.link--hidden {
		color: #000;
	}
	p {
		margin-bottom: 2em;
		line-height: 2em;
		font-weight: 300;
	}
	.quote {
		display: flex;
		font-weight: 300;
		line-height: 2em;
		margin-left: 0;
		margin-bottom: 40px;
		margin-top: 0;
	}

	.copyright {
		@include newsFont (#000, 14px, 400, 20px);
		font-style: italic;
	}
	.article-foot {
		background: #f7f7f7;
		padding: 30px 30px 5px;
		margin-bottom: 25px;
	}
</style>
